import React from 'react';
import PropTypes from 'prop-types';

import {
  ConfirmModal,
} from '../../../../components';

const DeleteMaterial = ({
  isOpen,
  isPending,
  onCloseModal,
  material,
  onDelete,
}) => (
  <ConfirmModal
    isOpen={isOpen}
    isPending={isPending}
    actionTitle="Delete"
    onAction={onDelete}
    onClose={onCloseModal}
    title="Delete material"
  >
    <span className="text-size--sm">
      Are you sure you want to delete a material
      {' '}
      <b>{material.title}</b>
?
    </span>
  </ConfirmModal>
);

DeleteMaterial.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  material: PropTypes.instanceOf(Object).isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeleteMaterial;
